import { Component, Input, OnInit } from '@angular/core';

import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import { transform as Transform } from 'ol/proj';
import Feature from 'ol/Feature';
import { Icon, Style } from 'ol/style';
import { Tile, Vector } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { easeIn } from 'ol/easing';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.sass'],
})
export class MapComponent implements OnInit {
  public map: Map;
  public view;
  public marker;
  public vectorSource;
  public vectorLayer;

  @Input() markerPosition: { lat: number; lng: number };
  @Input() markerImage: string;

  constructor() {
    /** */
  }

  ngOnInit() {
    this.initMap();
    setInterval(() => {
      this.map.updateSize();
    }, 1000);
  }

  /**
   * Init map
   * - center map
   * - add style to icon
   * - add style to map
   */

  initMap() {
    // Map style
    const bingLayer = new Tile({
      source: new OSM(),
    });

    // create Map

    this.map = new Map({ layers: [bingLayer], target: 'map' });

    // Set center
    this.view = new View({
      center: Transform([this.markerPosition.lat, this.markerPosition.lng], 'EPSG:4326', 'EPSG:3857'),
      zoom: 15,
    });

    this.map.setView(this.view);

    // create vector to storage the markers

    const iconStyle = new Style({
      image: new Icon({
        anchor: [0.5, 46],
        anchorXUnits: 'fraction',
        anchorYUnits: 'pixels',
        opacity: 1,
        src: this.markerImage,
      }),
    });

    this.vectorSource = new VectorSource({});

    this.vectorLayer = new Vector({
      source: this.vectorSource,
      style: iconStyle,
    });

    this.map.addLayer(this.vectorLayer);

    this.marker = new Feature({});
    this.vectorSource.addFeature(this.marker);
  }

  updateLocation(Location) {
    this.updateMarker([Location.lng, Location.lat], this.marker);
  }

  updateMarker(coordinates, feature) {
    const location = Transform(coordinates, 'EPSG:4326', 'EPSG:3857');
    feature.setGeometry(new Point(location));
    this.doBounce(location);
  }

  updateLocationCluster(Location) {
    this.marker = new Feature({});
    this.vectorSource.addFeature(this.marker);
    this.updateMarkerCluster([Location.lng, Location.lat], this.marker);
  }

  updateMarkerCluster(coordinates, feature) {
    const location = Transform(coordinates, 'EPSG:4326', 'EPSG:3857');
    feature.setGeometry(new Point(location));
    this.doBounce(location);
    this.map.getView().setCenter(location);
  }

  /**
   * Make a bounce in the map to a determinate location.
   * @param location location to make bounce.
   */
  doBounce(location) {
    this.view.animate({
      center: location,
      duration: 2000,
      easing: easeIn,
      zoom: 20,
    });
  }
}
